import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isLoading: false,
  reviews: [],
  error: {},
}

const ReviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    requestPending: (state) => {
      state.isLoading = true
    },

    getReviewsSuccess: (state, { payload }) => {
      state.isLoading = false
      state.reviews = payload || []
    },

    requestFail: (state, { payload }) => {
      state.isLoading = false
      state.error = payload
    },
  },
})

const { reducer, actions } = ReviewSlice
export const { requestPending, requestFail, getReviewsSuccess } = actions

export default reducer
